<script setup lang="ts">
import { ref } from 'vue'

import type { ContentfulNavigationItem } from '@fondof-ui/types'
import HeaderNavBrands from '@storefront-satch/components/organisms/navigation/HeaderNavBrands.vue'
import HeaderNavItem from '@storefront-satch/components/organisms/navigation/HeaderNavItem.vue'
import HeaderNavItemWishlist from '@storefront-satch/components/organisms/navigation/HeaderNavItemWishlist.vue'

const props = defineProps<{
  links: ContentfulNavigationItem[]
  isMobileOpen: boolean
  authorizationRedirectUri: string
  storefinder: {
    url: string
    label: string
  }
}>()

const currentActive = ref<string | undefined>()

const toggle = (entryId?: string) => {
  currentActive.value = entryId
}
</script>

<template>
  <nav
    :class="{ hidden: !props.isMobileOpen }"
    class="font-sans max-lg:absolute max-lg:right-0 max-lg:top-[47px] max-lg:z-10 max-lg:h-[calc(100dvh-theme(space.12))] max-lg:w-full max-lg:max-w-[500px] lg:block"
  >
    <div
      class="w-full bg-white max-lg:absolute max-lg:right-0 max-lg:top-0 max-lg:z-10 max-lg:overflow-y-auto lg:block lg:h-auto"
      :class="{
        'animate-fadeIn block h-full': props.isMobileOpen,
      }"
    >
      <ul
        v-if="links?.length > 0"
        class="mb-0 lg:flex lg:justify-end"
      >
        <HeaderNavItemWishlist
          :authorization-redirect-uri="props.authorizationRedirectUri"
          class="lg:hidden"
        />
        <HeaderNavItem
          v-for="(link, index) in links"
          :key="index"
          :current-active="currentActive"
          :nav-link="link"
          @toggle-menu="toggle"
        />
      </ul>

      <HeaderNavBrands :storefinder="props.storefinder" />
    </div>
  </nav>
</template>
